import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { TranslocoModule } from '@ngneat/transloco';
import { RxButtonModule } from '@roomex/rx-components';
import { TRANSLATION_SCOPE, translationProvider as TrainlineLinkTranslations } from './assets/i18n/translation.provider';

@Component({
  selector: 'rx-applications-trainline-link',
  standalone: true,
  imports: [CommonModule, RxButtonModule, TranslocoModule],
  templateUrl: './trainline-link.component.html',
  styleUrls: ['./trainline-link.component.scss'],
  providers: [TrainlineLinkTranslations],
})
export class TrainlineLinkComponent{
  @Input() trainlineHyperlink?: string;
  readonly TRANSLATION_SCOPE = TRANSLATION_SCOPE;

  navigateToTrainline(): void {
    const url = this.trainlineHyperlink?.length ? this.trainlineHyperlink : 'https://www.business.thetrainline.com/';
    window.open(url, '_blank');
  }
}
